import { render, staticRenderFns } from "./HKLHeader.vue?vue&type=template&id=3ac20ed4&scoped=true&"
import script from "./HKLHeader.vue?vue&type=script&lang=js&"
export * from "./HKLHeader.vue?vue&type=script&lang=js&"
import style0 from "./HKLHeader.vue?vue&type=style&index=0&id=3ac20ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac20ed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac20ed4')) {
      api.createRecord('3ac20ed4', component.options)
    } else {
      api.reload('3ac20ed4', component.options)
    }
    module.hot.accept("./HKLHeader.vue?vue&type=template&id=3ac20ed4&scoped=true&", function () {
      api.rerender('3ac20ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/HKLHeader.vue"
export default component.exports